import Blue from "~/core";

new Blue({
	name: 'solutionsHover',
	selector: ".solutionsHover",
	setup(solutionsHover) {



this.$addEvents('img', 'hover', {
    hover_delay: 0,
    sensitivity_delta: 0,
    sensitivity_delay: 0,
    in(e) {
        this.classList.add('is-hovered')
        hoverImage(this);
       
    },
    out(e) {
        this.classList.remove('is-hovered')
        unhoverImage(this);
      
    }
})
      
 
function hoverImage(element) {
   
   if (element.id == 'HealthCareProviders') element.setAttribute('src', '/img/content-images/HealthCareProvidersHover.png');
    else if (element.id == 'Researchers') element.setAttribute('src', '/img/content-images/ResearchersHover.png');
    else if (element.id == 'IndustryPartners') element.setAttribute('src', '/img/content-images/IndustryPartnersHover.png');
   
}

function unhoverImage(element) {
     
   if (element.id == 'HealthCareProviders') element.setAttribute('src', '/getattachment/0ff0a75c-07a0-4b2c-ad78-6093470c77e6/HealthCareProviders.png?lang=en-US&amp;ext=.png');
    else if (element.id == 'Researchers') element.setAttribute('src', '/getattachment/efa1e16b-df08-4603-891f-d612c0c24479/Researchers.png?lang=en-US&amp;ext=.png');
    else if (element.id == 'IndustryPartners') element.setAttribute('src', '/getattachment/65e1557f-8ca6-4303-a5a5-d1b8b5f65ce0/Icon-buliding.png?lang=en-US&amp;ext=.png');
   
}      

}
})